import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "count", "countDisplay"]
  static values = { resultsCount: Number, initialParams: Object }

  connect() {
    this.isOpen = false
    
    // 初期状態の設定とグローバル関数の登録
    if (this.hasPanelTarget) {
      this.panelTarget.style.transform = "translateX(100%)"
      window.openSearchOverlay = (searchParams = {}) => this.open(searchParams)
    }
    
    // 初期パラメータがある場合はそれを優先して使用
    this.defaultParams = this.hasInitialParamsValue ? this.initialParamsValue : {}
  }

  open(searchParams = {}) {
    this.isOpen = true

    // パラメータがない場合はデフォルトパラメータを使用
    const paramsToUse = Object.keys(searchParams).length > 0 ? searchParams : this.defaultParams

    // 検索パラメータがある場合はフォームに設定
    if (Object.keys(paramsToUse).length > 0) {
      this.setFormValues(paramsToUse)
    }

    // オーバーレイを表示
    this.element.classList.remove('hidden')

    // パネルをスライドイン
    if (this.hasPanelTarget) {
      requestAnimationFrame(() => {
        this.panelTarget.style.transform = "translateX(0%)"
      })
    }

    // bodyのスクロールを防ぐ
    document.body.style.overflow = 'hidden'

    // 件数を更新（search_form_controllerに委譲）
    const searchFormController = this.application.getControllerForElementAndIdentifier(this.element, 'search-form')
    if (searchFormController) {
      searchFormController.updateCount()
    }
  }

  setFormValues(searchParams) {
    const form = this.element.querySelector('form')
    if (!form) return

    Object.keys(searchParams).forEach(key => {
      const value = searchParams[key]
      if (!value || (Array.isArray(value) && value.length === 0)) return

      if (key === 'point') {
        this.setPointValues(form, value)
        return
      }

      const field = form.querySelector(`[name="${key}"]`)
      if (field) {
        if (field.type === 'checkbox' || field.type === 'radio') {
          field.checked = true
        } else {
          field.value = value
        }
        field.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }

  setPointValues(form, pointValues) {
    // pointValuesが配列でない場合は配列に変換
    const values = Array.isArray(pointValues) ? pointValues : [pointValues]
    
    // 既存のチェックをクリア
    const allCheckboxes = form.querySelectorAll('input[name="point[]"]')
    allCheckboxes.forEach(checkbox => {
      checkbox.checked = false
    })
    
    // 新しい値をチェック
    values.forEach(pointValue => {
      if (pointValue && pointValue.trim() !== '') {
        const checkbox = form.querySelector(`input[name="point[]"][value="${pointValue}"]`)
        if (checkbox) {
          checkbox.checked = true
        }
      }
    })
    
    // マルチセレクトドロップダウンの表示更新
    this.updateMultiSelectDisplay(form, values)
  }

  updateMultiSelectDisplay(form, selectedValues) {
    const multiSelectButton = form.querySelector('[data-multi-select-dropdown-target="button"] .button-text')
    if (multiSelectButton) {
      const validValues = selectedValues.filter(v => v && v.trim() !== '')
      if (validValues.length > 0) {
        if (validValues.length === 1) {
          multiSelectButton.textContent = `${validValues[0]} ▼`
        } else {
          multiSelectButton.textContent = `${validValues.length}件選択中 ▼`
        }
      } else {
        multiSelectButton.textContent = 'こだわり条件を選択 ▼'
      }
    }
    
    // マルチセレクトコントローラーがある場合はそちらも更新
    const multiSelectElement = form.querySelector('[data-controller*="multi-select-dropdown"]')
    if (multiSelectElement && window.Stimulus) {
      const controller = window.Stimulus.getControllerForElementAndIdentifier(multiSelectElement, 'multi-select-dropdown')
      if (controller && controller.updateButtonText) {
        controller.updateButtonText()
      }
    }
  }

  close() {
    this.isOpen = false
    
    if (this.hasPanelTarget) {
      // パネルをスライドアウト
      this.panelTarget.style.transform = "translateX(100%)"
      
      // アニメーション完了後にオーバーレイを非表示
      setTimeout(() => {
        this.element.classList.add('hidden')
      }, 300)
    } else {
      this.element.classList.add('hidden')
    }
    
    // bodyのスクロールを復元
    document.body.style.overflow = ''
  }

  updateCount(count) {
    if (this.hasCountTarget) {
      this.countTarget.textContent = count
      
      if (this.hasCountDisplayTarget) {
        this.countDisplayTarget.classList.add('animate-pulse')
        setTimeout(() => {
          this.countDisplayTarget.classList.remove('animate-pulse')
        }, 500)
      }
    }
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  disconnect() {
    document.body.style.overflow = ''
  }
}